/**
 * angular imports
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * constant imports
 */
import { COUNTRY_CONST, MAX_FILE_SIZE, MODULE_NAME } from 'src/app/constants/app.constants';
/**
 * file upload keeper service
 */
import { FileUploadKeeperService } from 'src/app/dataservices/file-upload-keeper.service';
import { UploadfileWithForkService } from 'src/app/dataservices/uploadfile-with-fork.service';


@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  constructor(public fileUpload: FileUploadKeeperService,
    private fileFok: UploadfileWithForkService
  ) {

  }
  /**
   * string for label
   */
  @Input() label;
  /**
   * formcontrol name
   */
  @Input() formControlName;


  @Input() mandatory=false;

  /**
   * preview image
   */
  public previewImage = '';

  public currentUploadedFile: string;

  public invalidFileSizeFlag: boolean;

  public errorMessage: string;

  public maxFileSize = MAX_FILE_SIZE;

  public isFileUplaodInProgress = false;

  @Input() invalidFileSizeMessage: string;

  /**
   * Emit the hidden and uploading event outside.
   */
  @Output() emitOnSuccesFullUpload: EventEmitter<void> = new EventEmitter();

  public validFileTypes =  ['image/png','image/jpg','image/jpeg', 'application/pdf'];
  /**
   * function to upload file
   * @param event 
   */
  public async fileUplaodStart(event): Promise<void> {
    this.invalidFileSizeFlag = true;
    const uploadFile = event.currentFiles[0];
    const mimeType = uploadFile.type;
    if (uploadFile.size > this.maxFileSize || this.validFileTypes.indexOf(mimeType) === -1 ) {
      this.invalidFileSizeFlag = true;
      return;
    }
    this.invalidFileSizeFlag = false;
    const fileType = this.fileUpload.setFileType(MODULE_NAME.PRIVATE, uploadFile.type);
    const productFileName = this.fileUpload.getValidFileName(uploadFile.name);
    this.isFileUplaodInProgress = true;
    await this.fileUpload.uploadFileOnKeeper(uploadFile,productFileName, MODULE_NAME.DQ, COUNTRY_CONST.IN, MODULE_NAME.PRIVATE, fileType).then(res => {
      this.currentUploadedFile = uploadFile.name;
      this.previewImage = res.signedUrl;
      this.isFileUplaodInProgress = false;
      if (mimeType === 'application/pdf' ) {
        this.fileFok.generatePdfThumbnail(uploadFile).then(data => {
          data = JSON.parse(data);
          this.previewImage = data['data'];
        })
      }
      this.emitOnSuccesFullUpload.emit(res.signedUrl);
    }).catch(error => {
      this.isFileUplaodInProgress = false;
    });
  }
  /**
   * function to remove file
   */
  removeFile(): void {
    this.previewImage = '';
    this.currentUploadedFile = null;
    this.emitOnSuccesFullUpload.emit(null);
  }
}
